import React, { useState } from 'react';
import './OnScreenKeyboard.css';

const LETTER_ROWS = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
];
const SYMBOL_ROWS = [
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  ['-', '/', ':', ';', '(', ')', '$', '&', '@', '"'],
  ['.', ',', '?', '!', "'"],
];

/**
 * Self-contained on-screen keyboard.
 *
 * Props:
 *   onKeyPress(char)  — called with a single character when a key is tapped
 *   onBackspace()     — called when ⌫ is tapped
 *   onSpace()         — called when space bar is tapped (optional; if omitted, no space bar shown)
 *   uppercase         — if true, letters are uppercase (default true)
 */
function OnScreenKeyboard({ onKeyPress, onBackspace, onSpace, uppercase = true }) {
  const [mode, setMode] = useState('letters'); // 'letters' | 'symbols'

  const toggleMode = () => setMode(mode === 'letters' ? 'symbols' : 'letters');
  const rows = mode === 'letters' ? LETTER_ROWS : SYMBOL_ROWS;
  const formatKey = (k) => (mode === 'letters' && !uppercase ? k.toLowerCase() : k);

  return (
    <div className="onscreen-keyboard">
      {rows.map((row, i) => {
        const isLastRow = i === rows.length - 1;
        return (
          <div className="kb-row" key={i}>
            {isLastRow && (
              <button
                type="button"
                className="kb-key kb-key-wide kb-key-mode"
                onClick={toggleMode}
              >
                {mode === 'letters' ? '.?123' : 'ABC'}
              </button>
            )}
            {row.map((key) => (
              <button
                type="button"
                className="kb-key"
                key={key}
                onClick={() => onKeyPress(formatKey(key))}
              >
                {formatKey(key)}
              </button>
            ))}
            {isLastRow && (
              <button
                type="button"
                className="kb-key kb-key-wide"
                onClick={onBackspace}
              >
                ⌫
              </button>
            )}
          </div>
        );
      })}
      {onSpace && (
        <div className="kb-row">
          <button type="button" className="kb-key kb-key-space" onClick={onSpace}>
            space
          </button>
        </div>
      )}
    </div>
  );
}

export default OnScreenKeyboard;
